module.exports = __webpack_public_path__ + "static/media/gmeet.d1ba0964.svg";